import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const AddDebtValidationSchema = yup.object({
  amount: yup.string().required("Amount is required"),
  note: yup.string(),
  paymentMethod: yup.string().required("Payment method is required"),
  //customerStoreId: yup.string().required("store is required"),
});

export const Validation = ({ customer }) => {
  return useForm({
    resolver: yupResolver(AddDebtValidationSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      amount: customer?.amount,
      note: customer?.note,
      paymentMethod: customer?.payment_method,
      //customerStoreId: customer?.store_id,
    },
  });
};
